export default "__VITE_ASSET__DHV$u7Sl__"